import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {toast} from 'sonner'
import {useTranslation} from 'react-i18next'
import {downloadInvoicePdf} from 'services/externalApi/invoicesApi'

const InvoiceDownloadMenuItem = ({Icon, itemId, title, rowData, handleClose, translationKey}) => {
    const {t} = useTranslation()

    const onClickHandler = (event) => {
        event?.stopPropagation()
        handleClose?.(event)

        toast.promise(
            downloadInvoicePdf(itemId, rowData?.number).catch((error) => {
                console.error('download invoice error', error)
                throw error
            }),
            {
                loading: t('loading'),
                success: () => t(`${translationKey}.success`),
                error: () => t(`${translationKey}.error`),
            }
        )
    }

    return (
        <MenuItem key={`table_action_${itemId}`} onClick={onClickHandler}>
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <div>{t(`menuItem.${title}`)}</div>
                {Icon && <Icon />}
            </Box>
        </MenuItem>
    )
}

export default InvoiceDownloadMenuItem
